module.exports = __webpack_public_path__ + "static/media/zander.a49a8c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/zander.png
// module id = 343
// module chunks = 0